function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.27677 0C3.20409 0.323701 0 3.73126 0 7.88718C0 12.257 3.54247 15.7995 7.91234 15.7995C11.2862 15.7995 14.1668 13.6879 15.3047 10.7142H7.27677V0ZM15.8118 8.34177C15.8204 8.19133 15.8247 8.03976 15.8247 7.88718C15.8247 4.31187 13.4533 1.29042 10.1976 0.309871V8.34177H15.8118Z",
  fill: "#119C59"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.126 8.39116V0.0185547C10.126 0.0185547 13.1309 0.926155 14.7099 3.60357C16.2889 6.28099 15.9744 8.39116 15.9744 8.39116H10.126Z",
  fill: "#25282B"
});

function SvgLbLogoMiniGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLbLogoMiniGreen);
export default __webpack_public_path__ + "static/media/lb-logo-mini-green.4b1a3518.svg";
export { ForwardRef as ReactComponent };